import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/explicación-de-la-ampliación-del-ivdr-consejos-y-estrategias")({
  head: () => buildRouteHead("/es/explicación-de-la-ampliación-del-ivdr-consejos-y-estrategias", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/webinars", replace: true });
  },
});
